export const formatToDesiredDisplayDate = (date: Date) => {
  const formattedDate = date.toLocaleString("default", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  });

  // If user has 12-hour format, make the default AM/PM lowercase
  const formattedDateParts = formattedDate.split(" ");
  const dateLastPart = formattedDateParts.slice(-1)[0];
  if (dateLastPart === "AM" || dateLastPart === "PM") {
    return formattedDateParts.slice(0, -1).join(" ") + dateLastPart.toLocaleLowerCase();
  }
  return formattedDate;
};
